import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/login/index.vue";
import Layout from "@/layout/index.vue";
// import routerList from '@/utils/routerList'
// import rolesMapper from '@/utils/rolesMapper'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/workplace",
  },
  // 登录
  {
    path: "/login",
    name: "LoginViews",
    component: Login,
  },
  {
    path: "/help",
    name: "Layout",
    component: Layout,
    redirect: "/help/helpIndex",
    children: [
      {
        path: "helpIndex",
        component: () => import("@/views/help/helpIndex"),
      },
    ],
  },
  {
    path: "/workplace",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/workplace"),
      },
    ],
  },
  {
    path: "/location",
    component: Layout,
    redirect: "/location/index",
    alwaysShow: true, // will always show the root menu
    name: "location",
    meta: { title: "统一保研院校定位程序", icon: "el-icon-s-order" },
    children: [
      {
        path: "index",
        component: () => import("@/views/location/index"),
      },
    ],
  },
  {
    path: "/university",
    component: Layout,
    redirect: "/university/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/university/index"),
        name: "university",
        meta: { title: "院校字典", icon: "el-icon-notebook-2" },
      },
    ],
  },
  {
    path: "/Information",
    component: Layout,
    redirect: "/Information/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/Information/index"),
        name: "Information",
        meta: { title: "推免信息", icon: "el-icon-notebook-2" },
      },
    ],
  },
  {
    path: "/dataBase",
    component: Layout,
    redirect: "/dataBase/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/dataBase/index"),
        name: "dataBase",
        meta: { title: "资料库", icon: "el-icon-notebook-2" },
      },
      {
        path: "smartAnswer",
        component: () => import("@/views/dataBase/smartAnswer"),
        name: "smartAnswer",
        meta: { title: "资料库", icon: "el-icon-notebook-2" },
      },
    ],
  },
  // 学员服务
  {
    path: "/studentServer",
    name: "Layout",
    redirect: "/studentServer/studentPannel",
    component: Layout,
    children: [
      {
        path: "deliveryList",
        component: () => import("@/views/studentServer/deliveryList"),
        name: "deliveryList",
        meta: { title: "学员投递列表" },
      },
      {
        path: "studentPannel",
        name: "studengPannel",
        component: () => import("@/views/studentServer/studentpannel"),
      },
      {
        path: "/studentServer/studentAssign",
        name: "studentAssign",
        component: () => import("@/views/studentServer/studentAssign"),
      },
      {
        path: "/studentServer/allocateSettings",
        name: "allocateSettings",
        component: () => import("@/views/studentServer/allocateSettings"),
      },
      {
        path: "/studentServer/allocateLogs",
        name: "allocateLogs",
        component: () => import("@/views/studentServer/allocateLogs"),
      },
      {
        path: "/studentServer/studentCoach",
        name: "studentCoach",
        component: () => import("@/views/studentServer/studentCoach"),
      },
      {
        path: "/studentServer/studentYouYing",
        name: "studentYouYing",
        component: () => import("@/views/studentServer/studentYouYing"),
      },
      {
        path: "/studentServer/xingHuo",
        name: "xingHuo",
        meta: {
          name: "星火回访",
        },
        component: () => import("@/views/studentServer/xingHuo"),
      },
      {
        path: "/studentServer/myStudent",
        name: "myStudent",
        meta: {
          name: "我的学员",
        },
        component: () => import("@/views/studentServer/myStudent"),
      },
      {
        path: "/studentServer/serverHistory",
        name: "serverHistory",
        meta: {
          name: "服务历史",
        },
        component: () => import("@/views/studentServer/serverHistory"),
      },
      {
        path: "/studentServer/satisfactionTabs",
        name: "satisfactionTabs",
        meta: {
          name: "满意度",
        },
        component: () => import("@/views/studentServer/satisfactionTabs"),
      },
      {
        path: "/studentServer/demand",
        name: "demand",
        meta: {
          name: "我发出的匹配需求",
        },
        component: () => import("@/views/studentServer/demand"),
      },
      {
        path: "/studentServer/studentDirection",
        name: "studentDirection",
        meta: {
          name: "学员去向",
        },
        component: () => import("@/views/studentServer/studentDirection"),
      },
      {
        path: "/studentServer/studentManage",
        name: "studentManage",
        meta: {
          name: "冻结学员管理",
        },
        component: () => import("@/views/studentServer/studentManage"),
      },
      {
        path: "/studentServer/freezeStudent",
        name: "freezeStudent",
        meta: {
          name: "我冻结的学员",
        },
        component: () => import("@/views/studentServer/freezeStudent"),
      },
      {
        path: "/studentServer/studentSchedule",
        name: "studentSchedule",
        meta: {
          name: "学员进度",
        },
        component: () => import("@/views/studentServer/studentSchedule"),
      },
      {
        path: "/studentServer/classHourStatistics",
        name: "studentSchedule",
        meta: {
          name: "课时统计",
        },
        component: () => import("@/views/studentServer/classHourStatistics"),
      },
      {
        path: "/studentServer/consumerStatistics",
        name: "consumerStatistics",
        meta: {
          name: "学员看板",
        },
        component: () => import("@/views/studentServer/consumerStatistics"),
      },
      {
        path: "/studentServer/refundedStudents",
        name: "refundedStudents",
        meta: {
          name: "退费学员列表",
        },
        component: () => import("@/views/studentServer/refundedStudents"),
      },
      {
        path: "/studentServer/appointmentDetails",
        name: "appointmentDetails",
        meta: {
          name: "预约明细",
        },
        component: () => import("@/views/studentServer/appointmentDetails"),
      },
      {
        path: "/studentServer/studentsclass",
        name: "studentsclass",
        meta: {
          name: "预约上课",
        },
        component: () => import("@/views/studentServer/studentsclass"),
      },
      {
        path: "/studentServer/classschedule",
        name: "classschedule",
        meta: {
          name: "上课日历",
        },
        component: () => import("@/views/studentServer/classschedule"),
      },
    ],
  },
  {
    path: "/statistic",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "/statistic/productConvert",
        name: "productConvert",
        component: () => import("@/views/statistic/productConvert"),
      },
      {
        path: "/statistic/academy",
        name: "academyView",
        component: () => import("@/views/statistic/academy"),
      },
      {
        path: "/statistic/specifiedConditions",
        name: "academyView",
        component: () => import("@/views/statistic/specifiedConditions"),
      },
      {
        path: "/statistic/payment",
        name: "payment",
        component: () => import("@/views/statistic/payment"),
      },
      {
        path: "/statistic/consumerRefund",
        name: "consumerRefund",
        component: () => import("@/views/statistic/consumerRefund"),
      },
      {
        path: "/statistic/consumerPayReturn",
        name: "consumerPayReturn",
        component: () => import("@/views/statistic/consumerPayReturn"),
      },
      {
        path: "/statistic/consumerPerformanceCommission/splitPerformance",
        name: "consumerPerformanceCommission",
        meta: {
          name: "业绩拆分",
        },
        component: () => import("@/views/statistic/splitPerformance"),
      },
      {
        path: "/statistic/consumerPerformanceCommission/performanceCommission",
        name: "consumerPerformanceCommission",
        meta: {
          name: "计算提成",
        },
        component: () => import("@/views/statistic/performanceCommission"),
      },
      {
        path: "/statistic/channelAgentFee",
        name: "channelAgentFee",
        meta: {
          name: "渠道代理费用",
        },
        component: () => import("@/views/statistic/channelAgentFee"),
      },
      {
        path: "/statistic/consumerCostOut",
        name: "consumerCostOut",
        meta: {
          name: "学员成本办结管理",
        },
        component: () => import("@/views/statistic/consumerCostOut"),
      },
      {
        path: "/statistic/partner",
        name: "partner",
        meta: {
          name: "合作方管理",
        },
        component: () => import("@/views/statistic/partner"),
      },
      {
        path: "/statistic/studentCost",
        name: "studentCost",
        meta: {
          name: "学员成本",
        },
        component: () => import("@/views/statistic/studentCost"),
      },
      {
        path: "/statistic/consumerRealClassHourChange",
        name: "consumerRealClassHourChange",
        meta: {
          name: "学员真实课时变更",
        },
        component: () =>
          import("@/views/statistic/consumerRealClassHourChange"),
      },
    ],
  },
  {
    path: "/research",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "/research/require",
        name: "require",
        component: () => import("@/views/research/require"),
      },
      {
        path: "/research/train",
        name: "train",
        component: () => import("@/views/research/train"),
      },
    ],
  },
  {
    path: "/ticket",
    component: Layout,
    redirect: "/ticket/manage",
    name: "Layout",
    meta: { name: "工单管理" },
    children: [
      {
        path: "manage",
        component: () => import("@/views/ticket/manage.vue"),
        name: "manage",
        meta: { title: "工单管理" },
      },
      {
        path: "myTicket",
        component: () => import("@/views/ticket/myTicket.vue"),
        name: "myTicket",
        meta: { title: "我的工单" },
      },
    ],
  },
  {
    path: "/salary",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "/salary/counselorBalance",
        name: "counselorBalance",
        component: () => import("@/views/salary/counselorBalance"),
      },
      {
        path: "/salary/salarySubmit",
        name: "salarySubmit",
        component: () => import("@/views/salary/salarySubmit"),
      },
      {
        path: "/salary/salaryCheck",
        name: "salarySubmit",
        component: () => import("@/views/salary/salaryCheck"),
      },
      {
        path: "/salary/salaryType",
        name: "salaryType",
        component: () => import("@/views/salary/salaryType"),
      },
      {
        path: "/salary/salaryResolution",
        name: "salaryResolution",
        component: () => import("@/views/salary/salaryResolution"),
      },
      {
        path: "/salary/monthSalary",
        name: "monthSalary",
        component: () => import("@/views/salary/monthSalary"),
      },
      {
        path: "/salary/nextMonthSalary",
        name: "nextMonthSalary",
        component: () => import("@/views/salary/nextMonthSalary"),
      },
      {
        path: "/salary/satisfactionSalary",
        name: "satisfactionSalary",
        component: () => import("@/views/salary/satisfactionSalary"),
      },
      {
        path: "/salary/historySalary",
        name: "historySalary",
        component: () => import("@/views/salary/historySalary"),
      },
      {
        path: "/salary/salaryFirst",
        name: "salaryFirst",
        component: () => import("@/views/salary/salaryFirst"),
      },
      {
        path: "/salary/salarySecond",
        name: "salarySecond",
        component: () => import("@/views/salary/salarySecond"),
      },
      {
        path: "/salary/salaryCheckList",
        name: "salaryCheckList",
        component: () => import("@/views/salary/salaryCheckList"),
      },
    ],
  },
  {
    path: "/counselor",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "/counselor/master",
        name: "master",
        component: () => import("@/views/counselor/master"),
      },
      {
        path: "/counselor/counselorCheck",
        name: "counselorCheck",
        component: () => import("@/views/counselor/counselorCheck"),
        meta: {
          name: "审核",
        },
      },
      {
        path: "/counselor/doctor",
        name: "doctor",
        component: () => import("@/views/counselor/doctor"),
        meta: {
          name: "博士",
        },
      },
      {
        path: "/counselor/doctorCheck",
        name: "doctor",
        component: () => import("@/views/counselor/doctorCheck"),
        meta: {
          name: "博士审核",
        },
      },
      {
        path: "/counselor/recommend",
        name: "recommend",
        component: () => import("@/views/counselor/recommend"),
        meta: {
          name: "推荐",
        },
      },
      {
        path: "/counselor/outCostRecord",
        name: "outCostRecord",
        component: () => import("@/views/counselor/outCostRecord"),
        meta: {
          name: "提现记录",
        },
      },
      {
        path: "/counselor/incomeRecord",
        name: "incomeRecord",
        component: () => import("@/views/counselor/incomeRecord"),
        meta: {
          name: "入账记录",
        },
      },
      {
        path: "/counselor/deductionRecords",
        name: "deductionRecords",
        component: () => import("@/views/counselor/deductionRecords"),
        meta: {
          name: "扣款记录",
        },
      },
    ],
  },
  {
    path: "/system",
    name: "Layout",
    component: Layout,
    redirect: "/system/accountManage",
    children: [
      {
        path: "accountManage",
        component: () => import("@/views/system/accountManage"),
        meta: {
          title: "系统账户管理",
        },
      },
      {
        path: "roleManagement",
        component: () => import("@/views/system/roleManagement"),
        meta: {
          title: "角色管理",
        },
      },
      {
        path: "studentAccount",
        component: () => import("@/views/system/studentAccount"),
        meta: {
          title: "学员账号",
        },
      },
      {
        path: "semesterManagement",
        component: () => import("@/views/system/semesterManagement"),
        meta: {
          title: "学期管理",
        },
      },
      {
        path: "courseManagement",
        component: () => import("@/views/system/courseManagement"),
        meta: {
          title: "课程管理",
        },
      },
      {
        path: "competitionManagement",
        component: () => import("@/views/system/competitionManagement"),
        meta: {
          title: "竞赛管理",
        },
      },
    ],
  },
  {
    path: "/officialWebSite",
    name: "Layout",
    component: Layout,
    redirect: "/officialWebSite/courseEntry",
    children: [
      {
        path: "courseManagement",
        component: () => import("@/views/officialWebSite/courseManagement"),
        meta: {
          title: "课程管理",
        },
      },
      {
        path: "courseEntry",
        component: () => import("@/views/officialWebSite/courseEntry"),
        meta: {
          title: "课题管理",
        },
      },
      {
        path: "subjectManage",
        component: () => import("@/views/officialWebSite/subjectManage"),
        meta: {
          title: "学科大类管理",
        },
      },
    ],
  },
  {
    path: "/toolsPage",
    name: "Layout",
    component: Layout,
    redirect: "/toolsPage/toolsPage",
    children: [
      {
        path: "toolsPage",
        component: () => import("@/views/toolsPage/toolsPage"),
        meta: {
          title: "身份证核验",
        },
      },
    ],
  },
  {
    path: "/topicsPage",
    name: "Layout",
    component: Layout,
    redirect: "/topicsPage/topicsPage",
    children: [
      {
        path: "topicsPage",
        component: () => import("@/views/topicsPage/topicsPage"),
        meta: {
          title: "真题审核",
        },
      },
    ],
  },
  {
    path: "/exam",
    name: "exam",
    component: Layout,
    redirect: "/exam/exampage",
    children: [
      {
        path: "exampage",
        component: () => import("@/views/exam/index.vue"),
        meta: {
          title: "试卷管理",
        },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

// export const increateMapper = () => {
//   // 拿到当前的路由
//   const currentRouter = router.options.routes
//   console.log(currentRouter, 'currentRouter')
//   const rights = window.localStorage.getItem('permissions').split(',')
//   rights.forEach(item => {
//     console.log(item, 'item')
//     if (rolesMapper[item]) {
//       const temp = rolesMapper[item]
//       currentRouter[2].children.push(temp)
//       return false
//     }
//   })
//   // 自己设置的路由信息
//   // routerList.routerList.forEach(item => {
//   //   rights.forEach(it => {
//   //     if (item.name && item.name === it) {
//   //       item.hidden = true
//   //       const temp = rolesMapper[item.name]
//   //       currentRouter[2].children.push(temp)
//   //     }
//   //     if (item.children) {
//   //       item.children.forEach(ele => {
//   //         if (ele.name && ele.name === it) {
//   //           ele.hidden = true
//   //           const temp = rolesMapper[ele.name]
//   //           currentRouter[2].children.push(temp)
//   //         }
//   //       })
//   //     }
//   //   })
//   // })
//   router.addRoutes(currentRouter)
//   console.log(routes, 'routes')
// }

// const rights = ['T_WIKI', 'T_ACCOUNT_GENERAL', 'T_CONSUMER_ALLOCATE']
// export const mapperList = () => {
//   // 拿到当前的路由信息
//   const currentRouter = router.options.routes
//   rights.forEach(item => {
//     const temp = rolesMapper[item]
//     currentRouter[2].children.push(temp)
//   })
// }

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  // console.log(to, 'to')
  // console.log(from, 'from')
  if (to.path !== "/login") {
    if (token) {
      next();
    } else {
      next("/login");
    }
  }
  next();
});

// 捕获路由异常的错误
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
